export const tasks = {
    aircraftChanged: ['Произошла замена ВС', 'The aircraft was changed'],
    confirmReplaceData: [
        'Вы хотите заменить локальные данные внешними? Все несохраненные данные будут потеряны',
        'Do you want to replace the local data with the external data? All the unsaved data will be lost.',
    ],
    earlierCfpNotPlan: ['CFP, полученный ранее, может не соответствовать плану', 'CFP received earlier may not match the plan'],
    failedRemoveTask: ['Не удалось удалить задание!', 'Failed to remove task!'],
    removeAllTaskData: [
        'Вы действительно хотите удалить ВСЕ данные по ПЗ с устройства? Рекомендуется использовать при наличии интернета',
        'Do you really want to remove ALL task data from device? We recommend to use if you have Internet',
    ],
};
